import { PuxButton, PuxLogo, PuxSpinner } from "@phonero/pux-react"
import css from "./Checkout.module.scss"
import { PaymentMethod } from "@phonero/common-graphql/types"
import { featureFlags } from "../../../appConstants"
import { paymentVariation } from "../calculatePaymentVariation"
import { dataCy, useAppTranslations, VippsButton } from "@phonero/common-ux"

export const SelectPaymentMethod = ({
  onPaymentClick,
  disabled,
  variant,
  loadingProductData,
}: {
  variant: paymentVariation
  subscriptionId: string
  product: any
  disabled: boolean
  loadingProductData: boolean
  onPaymentClick: (method: PaymentMethod) => void
}) => {
  const { t } = useAppTranslations()

  const isNotAVippsOnlyCustomer =
    variant !== paymentVariation.Variant2KunPrivatBetalingSomFeksVipps &&
    !loadingProductData
  const methodMobileButton =
    isNotAVippsOnlyCustomer &&
    t("SelectPaymentMethod.MobileButton", { context: String(variant) })

  return (
    <div>
      <div className={css.paymentButtons}>
        {isNotAVippsOnlyCustomer && (
          <PuxButton
            disabled={disabled}
            expand="block"
            className={css.button}
            style={{
              fontWeight: "bold",
              fontSize: "2rem",
              marginTop: "20px",
            }}
            color="medium"
            {...dataCy("pay-cellular")}
            onClick={() => onPaymentClick(PaymentMethod.Mobile)}
          >
            {methodMobileButton}
          </PuxButton>
        )}
        {loadingProductData && <PuxSpinner style={{ marginBlock: "20px" }} />}
        {featureFlags.vipps && (
          <VippsButton
            {...dataCy("pay-vipps-new")}
            onClick={() => onPaymentClick(PaymentMethod.Vipps)}
            disabled={disabled}                        
          />
        )}
      </div>
    </div>
  )
}
